
import * as Components from "./Kokoroll"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "kokoroll"
}

